/**
 * Bridges the save-confirmation toast's "Download PDF" click (fired from
 * `usePlanWizardMutations`, mounted only while the wizard is up) to the real
 * PDF-download capability, which only exists once `PlansPage` is mounted
 * (`usePlanEllipsisOptions().handleAction('downloadPDFEnglish', id)`) —
 * mirrors Invoices' own `invoicePrintBridge.ts`.
 */
type PlanPrinter = (planId: string) => void;

let printer: PlanPrinter | null = null;

export const registerPlanPrinter = (fn: PlanPrinter | null): void => {
  printer = fn;
};

export const printPlanViaBridge = (planId: string): void => {
  printer?.(planId);
};
